<div>
    <div class="row">
        <div class="col-3 d-inline">
            <label class="fw-semibold gray-color ">Nombre de la lista </label>
        </div>
        <div class="col-4 d-inline">
            <input type="text" style="border-radius: 5px; text-align: center;" [(ngModel)]="iso">
        </div>
        
        <div class="col-5 d-inline">
            <!--span class="badge" [ngClass]="{'badge-primary': currentlistcfd, 'badge-secondary': !currentlistcfd}">
                {{ currentlistcfd ? 'CFD' : 'STK' }}
            </span-->
            <span class="badge" [ngClass]="{'badge-primary': metaapi, 'badge-secondary': !metaapi}">
                {{ metaapi ? 'MetaAPI' : 'Nectum' }}
            </span>
            <button mat-flat-button (click)="CrearLista()" class="ccorbit">
                  <mat-icon class="me-1">playlist_add</mat-icon>
                Crear Lista
            </button>
        </div>
    </div>
    <div class="row mt-2">
        <cdk-virtual-scroll-viewport #listaComp id="listaComp" item [appendOnly]="false" [tvsItemSize]="24"
            [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
            <table cdk-table [dataSource]="companias" class="table-striped tableStyle">

                <!-- Position Column -->
                <ng-container cdkColumnDef="n">
                    <th cdk-header-cell *cdkHeaderCellDef class="first-column sticky-header"> #.
                    </th>
                    <td cdk-cell *cdkCellDef="let element" class="first-column"> {{element.n}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container cdkColumnDef="iso">
                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"> Compañia </th>
                    <td cdk-cell *cdkCellDef="let element" class="first-column"> <a class="activo-link" [href]="urlMercadoActivo(element)" target="_blank">{{element.iso}} <mat-icon>open_in_new</mat-icon></a> </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container cdkColumnDef="descripcion">
                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> Descripcion </th>
                    <td cdk-cell *cdkCellDef="let element"> {{element.descripcion}} </td>
                </ng-container>

                <!--                 <ng-container cdkColumnDef="tipo">
                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"> Tipo
                    </th>
                    <td cdk-cell *cdkCellDef="let element" class="first-column"> {{element.tipo}}
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="mercado">
                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column">
                        Mercado </th>
                    <td cdk-cell *cdkCellDef="let element" class="first-column"> {{element.mercado}}
                    </td>
                </ng-container> -->
                <ng-container cdkColumnDef="eliminar">
                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> Eliminar </th>
                    <td cdk-cell *cdkCellDef="let element">
                        <button (click)="EliminarCompania(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </cdk-virtual-scroll-viewport>

    </div>

</div>